import { FC } from 'react';
import ProButton, { ButtonProps } from './button';
import ProButtonGroup, { ButtonGroupProps } from './group';

export type IButtonComponent = FC<
  ButtonProps & React.RefAttributes<HTMLElement>
> & {
  Group: FC<ButtonGroupProps>;
};

const TransButton = ProButton as IButtonComponent;
TransButton.Group = ProButtonGroup;

export default TransButton;
